import React from "react";
import { connect } from "react-redux";
import SearchLg from "@untitled-ui/icons-react/build/esm/SearchLg";
import FolderPlus from "@untitled-ui/icons-react/build/esm/FolderPlus";
import Folder from "@untitled-ui/icons-react/build/esm/Folder";
import Save01 from "@untitled-ui/icons-react/build/esm/Save01";
import Edit01 from "@untitled-ui/icons-react/build/esm/Edit01";
import ThumbsUp from "@untitled-ui/icons-react/build/esm/ThumbsUp";
import ThumbsDown from "@untitled-ui/icons-react/build/esm/ThumbsDown";
import Play from "@untitled-ui/icons-react/build/esm/Play";
import CreditCardUp from "@untitled-ui/icons-react/build/esm/CreditCardUp";
// import Trash01 from "@untitled-ui/icons-react/build/esm/Trash01";
import Trash01 from "@untitled-ui/icons-react/build/esm/FileX03";

import { FloatButton } from "antd";
import FloatButtonComp from "../FloatButtonComp";

//PROJECT IMPORTS
import { rightAction } from "../../redux/actions/blockAction";

const RightSidebar = (props) => {
  const {
    rightBtn,
    onSearch,
    onAdd,
    onView,
    onSave,
    onEdit,
    onDelete,
    onApprove,
    onReject,
    onDisburse,
    onRun,
    approveTooltipTitle = "Approve",
    rejectTooltipTitle = "Reject",
    disableStatus,
  } = props;

  return (
    <FloatButton.Group
      shape="square"
      style={{
        right: 20,
        bottom: "22%",
      }}
      type="primary"
    >
      <FloatButtonComp
        icon={SearchLg}
        tooltip="Search"
        theme={rightBtn.searchBtn}
        onClick={onSearch}
        isDisabled={
          rightBtn.searchBtn?.toLowerCase() === "primary" ? false : true
        }
      />
      <FloatButtonComp
        icon={FolderPlus}
        tooltip="Add"
        theme={rightBtn.addBtn}
        onClick={onAdd}
        // isDisabled={disableStatus ? disableStatus:true}
        isDisabled={rightBtn.addBtn?.toLowerCase() === "primary" ? false : true}
      />
      <FloatButtonComp
        icon={Folder}
        tooltip="View Detail"
        theme={rightBtn.detailBtn}
        onClick={onView}
        isDisabled={
          rightBtn.detailBtn?.toLowerCase() === "primary" ? false : true
        }
      />
      <FloatButtonComp
        icon={Save01}
        tooltip="Save"
        theme={rightBtn.saveBtn}
        onClick={onSave}
        isDisabled={
          rightBtn.saveBtn?.toLowerCase() === "primary" ? false : true
        }
      />
      <FloatButtonComp
        icon={Edit01}
        tooltip="Edit"
        theme={rightBtn.editBtn}
        onClick={onEdit}
        isDisabled={
          rightBtn.editBtn?.toLowerCase() === "primary" ? false : true
        }
      />
      <FloatButtonComp
        icon={Trash01}
        tooltip="Close"
        theme={rightBtn.deleteBtn}
        onClick={onDelete}
        isDisabled={
          rightBtn.deleteBtn?.toLowerCase() === "primary" ? false : true
        }
      />
      <FloatButtonComp
        icon={ThumbsUp}
        tooltip={approveTooltipTitle}
        theme={rightBtn.approveBtn}
        onClick={onApprove}
        isDisabled={
          rightBtn.approveBtn?.toLowerCase() === "primary" ? false : true
        }
      />
      <FloatButtonComp
        icon={ThumbsDown}
        tooltip={rejectTooltipTitle}
        theme={rightBtn.rejectBtn}
        onClick={onReject}
        isDisabled={
          rightBtn.rejectBtn?.toLowerCase() === "primary" ? false : true
        }
      />

      <FloatButtonComp
        icon={CreditCardUp}
        tooltip="Disburse"
        theme={rightBtn.disburseBtn}
        onClick={onDisburse}
        isDisabled={
          rightBtn.disburseBtn?.toLowerCase() === "primary" ? false : true
        }
      />

      <FloatButtonComp
        icon={Play}
        tooltip={"Run"}
        theme={rightBtn.runBtn}
        onClick={onRun}
        isDisabled={rightBtn.runBtn?.toLowerCase() === "primary" ? false : true}
      />

      {/* <FloatButton icon={<DeleteOutlined />} tooltip={<div>Delete</div>} />
      <FloatButton icon={<LikeOutlined />} tooltip={<div>Approve</div>} />
      <FloatButton icon={<DislikeOutlined />} tooltip={<div>Dissaprove</div>} /> */}
      <FloatButton.BackTop
        visibilityHeight={0}
        tooltip={<div>Back to Top</div>}
      />
    </FloatButton.Group>
  );
};

const mapStateToProps = (state) => {
  return {
    rightBtn: state.RightSideBtn,
  };
};

export default connect(mapStateToProps, null)(RightSidebar);
